export const INFRA_PROVIDER =
  process.env.REACT_APP_INFRA_PROVIDER || 'firebase';

export const isSelfHosted = INFRA_PROVIDER === 'selfhosted';

export const AUTH_TOKEN_KEY = 'authToken';
export const AUTH_REFRESH_TOKEN_KEY = 'authRefreshToken';
export const AUTH_TOKEN_EXPIRES_KEY = 'authTokenExpiresAt';
export const AUTH_USER_KEY = 'authUser';
export const AUTH_SESSION_EVENT = 'mayorx-admin-auth-changed';

export interface StoredAuthUser {
  uid: string;
  email?: string | null;
  displayName?: string | null;
  organizationId?: string | null;
  role?: string | null;
}
